import { Suspense } from 'react'

import { AppId } from '@inno-tools/container-bridge'
import { Spinner } from '@inno-ui/spinner'
import { AfterSalesApp } from 'modules/app-registry/components/AfterSalesApp'
import { useAvailableApps } from 'modules/app-registry/hooks/useAvailableApps'
import { AppSessionTopBar } from 'modules/desktop/components/AppSessionTopBar'
import { Navigate } from 'react-router-dom'
import { useUserContext } from 'shared/hooks'

import styles from './AppSessionRouter.module.scss'

export const AppSessionRouter = () => {
  const { user } = useUserContext()
  const { apps, isLoading } = useAvailableApps()

  if (!user || isLoading) {
    return <Spinner />
  }

  if (user.user_roles?.includes('anonymous')) {
    return <Navigate to='/login' replace />
  }

  if (!apps[AppId.AFTER_SALES]) {
    return <Navigate to='/' replace />
  }

  return (
    <>
      <AppSessionTopBar />
      <div className={styles.content}>
        <Suspense fallback={<Spinner />}>
          <AfterSalesApp />
        </Suspense>
      </div>
    </>
  )
}
